import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-add-credit-form',
  templateUrl: './add-credit-form.component.html',
  styleUrls: ['./add-credit-form.component.css']
})
export class AddCreditFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
